export default "__VITE_ASSET__C7C6HEjX__"